import { render } from "./PromptPage.vue?vue&type=template&id=0d3694e1"
import script from "./PromptPage.vue?vue&type=script&lang=js"
export * from "./PromptPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__